import type { OrgDefaultSettingsDTO, ProjectSettingsOverridesDTO } from '@api/fastAPI.schemas'

export type SettingKey = keyof OrgDefaultSettingsDTO & keyof ProjectSettingsOverridesDTO

/** The settings shown in the Konfiguration section, in display order. */
export const configurationSettings: { key: SettingKey; label: string }[] = [
  {
    key: 'include_inner_forces_plots',
    label: 'Bemessungsschnittgrößen Grafiken in der Dokumentation inkludieren',
  },
]

/** Select value of a project setting that follows the organisation default. */
export const FOLLOW_ORGANISATION = 'organisation'

export type ProjectSettingValue = typeof FOLLOW_ORGANISATION | 'true' | 'false'

export const toProjectSettingValue = (value?: boolean | null): ProjectSettingValue =>
  value === undefined || value === null ? FOLLOW_ORGANISATION : value ? 'true' : 'false'

export const fromProjectSettingValue = (value: ProjectSettingValue): boolean | null =>
  value === FOLLOW_ORGANISATION ? null : value === 'true'
